import { render, staticRenderFns } from "./ProductFields.vue?vue&type=template&id=52c6d3f4&"
import script from "./ProductFields.vue?vue&type=script&lang=js&"
export * from "./ProductFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports